import React from "react";
import styled from "styled-components";
import UnderlinedHeader from "../../molecules/UnderlinedHeader/UnderlinedHeader";
import { Container } from "react-bootstrap";

const Returns = () => (
  <Wrapper>
    <Container>
      <UnderlinedHeader text={"30 Day Return"} bolder />
      <p>
        If you are not satisfied with your purchase, please follow the
        instructions below to return the item.
      </p>
      <p>
        Returns are acceptable within 30 days from the day of purchase (date of
        invoice).
      </p>
      <p>
        All returns must be in their original condition, originally packed
        (without any signs of opening) and include all original manufacturer's
        packaging and/or tags.
      </p>
      <p>
        If any parts were purchased as a set, it is not possible to return its
        individual components. In such cases, it is possible to return the
        entire set only containing all components. Returns of a single set's
        components' will be rejected and sent back at the customer's cost.
      </p>
      <p>
        Please email us at{" "}
        <StyledLink href={"mailto:support@pedders.eu"}>
          support@pedders.eu
        </StyledLink>{" "}
        before returning any products.
      </p>
      <p>
        Important! Please, make sure that you include in the parcel filled
        Return Form (
        <StyledLink
          target={"_blank"}
          href={"http://dba4x4.home.pl/warranty/return/"}
          rel={"noopener noreferrer nofollow"}
        >
          you can download here
        </StyledLink>
        ), together with a copy of the receipt and send it within 30 days from
        the day of purchase (date of receipt).
      </p>
      <p>
        Any returns not approved by us will be refused. You will be responsible
        for shipping to us and back to you so be sure to contact us prior to
        taking any action.
      </p>
      <p>
        When shipping returned items, you are responsible to pack and ship items
        properly so the items do not get damaged or lost in transit.
      </p>
      <p>
        We will be glad to refund undamaged and unused items with no restocking
        fee within 30 days from the date of sale.
      </p>
    </Container>
  </Wrapper>
);

export default Returns;

const Wrapper = styled.section`
  padding-top: 92px;
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
  color: #666666;
`;

const StyledLink = styled.a`
  font-weight: 600;
  color: #666666;
`;
